import { render, staticRenderFns } from "./surgery_calendar.vue?vue&type=template&id=4470f50c&scoped=true&"
import script from "./surgery_calendar.vue?vue&type=script&lang=js&"
export * from "./surgery_calendar.vue?vue&type=script&lang=js&"
import style0 from "./surgery_calendar.vue?vue&type=style&index=0&id=4470f50c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470f50c",
  null
  
)

export default component.exports